import { useMutation } from '@apollo/client';
import React, { useState } from 'react';
import AdminModal from '../../../components/AdminModal';
import useToast from '../../../customHooks/useToast';
import { UPDATE_PARTNER_STATUS } from '../../../graphql/admin_mutations';

import RoundMinusIcon from '../../../svgs/RoundMinusIcon';
import Styles from './DeactivatePartner.module.scss';

interface IDeactivatePartner {
  onClose: any;
  payload: any;
  refetch: any;
}
const DeactivatePartner = ({
  onClose,
  payload,
  refetch,
}: IDeactivatePartner) => {
  const Toast = useToast();

  const [isSuccessful, setIsSuccessful] = useState(false);
  const [deactivate, { loading: deactivateLoading }] = useMutation<
    { updatePartnerStatus: any },
    any
  >(UPDATE_PARTNER_STATUS);

  const activateAndDeactivatePartner = async () => {
    const data = { partnerId: payload?.id, isActive: false };
    if (!deactivateLoading) {
      try {
        const res = await deactivate({
          variables: data,
        });

        if (
          res?.data?.updatePartnerStatus
          && res?.data?.updatePartnerStatus?.status === 200
        ) {
          refetch?.();
          setIsSuccessful(true);
        } else {
          Toast.error(
            res?.data?.updatePartnerStatus?.message || 'Operation failed',
          );
        }
      } catch (e) {
        if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
          Toast.error(e.graphQLErrors[0].message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
  };

  return (
    <div className={Styles.wrapper}>
      <AdminModal
        headText={
          isSuccessful
            ? 'Partner Deactivated!'
            : 'Are you sure you want to deactivate this partner?'
        }
        subText={
          isSuccessful
            ? `${payload?.name} has been deactivated successfully.`
            : 'By clicking on "Deactivate", the partner and their tracking code will be deactivated. If you are not sure, please cancel.'
        }
        actionBtnName="Yes, deactivate"
        handleModalAction={activateAndDeactivatePartner}
        topIcon={(
          <div className={Styles.wrapper__icon}>
            <RoundMinusIcon />
          </div>
        )}
        isShow
        isActionBtnDisabled={deactivateLoading}
        isSuccess={isSuccessful}
        isTopIcon
        onClickAway={onClose}
        onClose={onClose}
        isLoading={deactivateLoading}
        hideLogo
        cancelBtnClass={Styles.wrapper__cancelBtn}
        actionBtnClass={
          isSuccessful ? Styles.wrapper__okayBtn : Styles.wrapper__deactivateBtn
        }
      />
    </div>
  );
};

export default DeactivatePartner;
